// extracted by mini-css-extract-plugin
export var fileExt = "_va-8";
export var fileIcon = "_va-6";
export var fileLink = "_va-5";
export var fileName = "_va-7";
export var image = "_va-1";
export var imageError = "_va-3";
export var imageErrorIcon = "_va-4";
export var imageLink = "_va-0";
export var imageLoaded = "_va-2";